var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCrossDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    stroke: "#FFFFFF",
    d: "M11.4831296,8.98745858 C12.1722901,9.67661914 12.1722901,10.7939691 11.4831296,11.4831296 C10.7939691,12.1722901 9.67661914,12.1722901 8.98745858,11.4831296 L6,8.49567098 L3.01254142,11.4831296 C2.32338086,12.1722901 1.20603093,12.1722901 0.516870369,11.4831296 C-0.172290123,10.7939691 -0.172290123,9.67661914 0.516870369,8.98745858 L3.50432902,6 L0.516870369,3.01254142 C-0.172290123,2.32338086 -0.172290123,1.20603093 0.516870369,0.516870369 C1.20603093,-0.172290123 2.32338086,-0.172290123 3.01254142,0.516870369 L6,3.50432902 L8.98745858,0.516870369 C9.67661914,-0.172290123 10.7939691,-0.172290123 11.4831296,0.516870369 C12.1722901,1.20603093 12.1722901,2.32338086 11.4831296,3.01254142 L8.49567098,6 L11.4831296,8.98745858 Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCrossDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cross-Disabled.b2a04371.svg";
export { ForwardRef as ReactComponent };